import {computed, observable, makeObservable} from 'mobx';
import {BaseModel} from "../../../../../infrastructure/models/base-model";
import {FooterModuleDynamicLinkModel} from "./footer-module.dynamic-link.model";
import type {FooterModuleTerms} from "../footer-module.terms";
import type {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import type {LanguageViewModel} from "../../../../../domain/locale/models/language/language.view-model";

export class FooterModuleDynamicLinksModel extends BaseModel {
  terms: FooterModuleTerms;
  @observable language: FooterModuleTerms;
  @observable sportTypeId: Number;
  @observable userCountryId: Number;
  @observable currentLinkModel: BaseLinkModel

  constructor(
    model,
    language: LanguageViewModel,
    sportTypeId: Number,
    userCountryId: Number,
    terms: FooterModuleTerms,
    currentLinkModel: BaseLinkModel
  ) {
    super();

    this.model = model;
    this.language = language;
    this.sportTypeId = sportTypeId;
    this.userCountryId = userCountryId;
    this.terms = terms;
    this.currentLinkModel = currentLinkModel;

    makeObservable(this);
  }

  @computed get links() {
    const dynamicsLinks: Array<FooterModuleDynamicLinkModel> =
      this.model.dynamicLinks?.map((link: FooterModuleDynamicLinkModel) => new FooterModuleDynamicLinkModel(
        link, this.language, this.sportTypeId, this.userCountryId, this.currentLinkModel, this.terms[link.anchorText]));

    return dynamicsLinks;
  }
}
